module.exports = __webpack_public_path__ + "img/41.3.TP.5443ded9.png";